export default __webpack_public_path__ + "static/media/woman-thinking.e5cf5fbc.png";